import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import update from 'immutability-helper';
import Field from 'components/Form/Field';
import Delete  from '../Buttons/Delete';
import Price from "components/Formaters/Price";

import { orders, products, brands } from "data/actions";

class OrderProductEditor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
}

  componentWillReceiveProps = (e) => {
    this.setState({
      value: e.value,
    });
  }

  componentWillMount() {
    this.props.actions.fetchBrands();
    this.props.actions.fetchProducts();
    this.props.actions.fetchOrders();
  }

  static contextTypes = {
    router: PropTypes.object
  };


  handleChannelNameChange = (key, field) => {

    const next = update(this.state, { 
      value: { 
        [key]: {
          name: {$set: field.state.value}
        }
      }
    });
    this.setState(next);
    
  }


  handleChannelTypeChange = (key, event, index, value) => {
    const next = update(this.state, { 
      value: { 
        [key]: {
          categoryid: {$set: value}
        }
      }
    });
    this.setState(next);
  }

  handleReportsSubmit = () => {

  }
  
  handleValueChange = (id, field) => {
    console.log(id, field) 
    const next = update(this.state, { 
        value: { 
            [id]:{$set: {value: field.state.value}}
        }
    });
    this.setState(next);
}

  renderReports = () => {
    return _.map(this.props.order.bookings, (b, key) => {
      var p = this.props.products[b.productid];
      if (p) {
        var brand = this.props.brands[p.brandid];
        if (brand) {
          var pos = p.positions[b.positionid];
          return (
            <li key={key} className="campaign_item">
              <span className="campaign_item_header">
                <span className="campaign_item_product">{p.name}</span>
                <span className="campaign_item_brand">{brand.name}</span>
                <span className="campaign_item_brand_logo">
                  <img alt={brand.name} src={brand.logoUrl} />
                </span>
              </span>
              <span className="campaign_item_price">
                Pris: <Price value={p.netprice} />
              </span>
              <span className="campaign_item_position">
                Plats: {pos ? pos.value : "Ej spec"}
              </span>
              <span className="campaign_item_editions">
                Utgåvors: 
              </span>
              <Field
                floatingLabelText="bruttokontakter"
                ref="bruttokontakter"
                value={b.bruttokontakter}
                handleChange={this.handleValueChange.bind(this,key)} 
              />
            </li>
          );
        }
      }
    });
  };

  render() {
    return (
      <div className="OrderProductEditor">
        <ul className="campaign_booking">
          {this.renderReports()}
        </ul>
        <RaisedButton
                onTouchTap={this.handleReportsSubmit.bind(this)}
                primary={true}
                label="Spara"
              />
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  var order = {};
  console.log(ownProps)
  _.forEach(state.orders.list.data, (a, ka) => {
    _.forEach(a, (c, kc) => {
      if ( kc === ownProps.id) {
        order = c;
      }
    });
  });
  return {
    order: order,
    user: state.auth.user,
    products: state.products.list.data,
    brands: state.brands.list.data,
    pending: state.orders.list.pending
  };
}

const mapDispatch = dispatch => {
  return {
    actions: bindActionCreators({ ...products, ...orders, ...brands }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch, null, {withRef:true})(OrderProductEditor)

  



// WEBPACK FOOTER //
// ./src/components/Form/OrderProductEditor.jsx